import React from "react";
import { VstDropdown } from "vstui";
import { Isvg } from "../../components";

export default class MarkerDropdownItem extends React.Component {
  constructor() {
    super();
    this.select = this.select.bind(this);
  }

  select() {
    this.props.select(this.props.marker.globalId);
  }

  render() {
    const { marker, selected } = this.props;
    return (
      <VstDropdown.Item onClick={this.select} selected={selected}>
        <div
          className="marker-circle"
          style={{
            background: marker.color,
            border: `1px solid ${marker.darkColor}`
          }}
        >
          {marker.shared && (
            <Isvg
              style={{ color: marker.darkColor }}
              src="/img/public_icon.svg"
            />
          )}
        </div>
        {marker.label.length > 25
          ? `${marker.label.slice(0, 25)}...`
          : marker.label}
      </VstDropdown.Item>
    );
  }
}
